<script>
  import Vue from 'vue';
  import VueChartJs from 'vue-chartjs';
  export default {
    name: 'line-chart',
    extends: VueChartJs.Line,
    mixins: [VueChartJs.mixins.reactiveProp],
    props: ['options'],
    mounted () {
      this.fillData()
    },
    methods: {
      fillData () {
        this.renderChart(this.chartData, this.options || {reponsive: true, maintainAspectRatio: false});
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/LineChart.vue